<template>
    <span>
        <b-badge :variant="variant">{{ quantidade }}</b-badge>
    </span>
</template>

<script>
export default {
    props: {
        quantidade: {
            type: [Number, String],
            default: 0
        }
    },

    computed: {
        variant() {
            const qtd = Number(this.quantidade) || 0
            
            if (qtd === 0) {
                return 'secondary'
            } else if (qtd >= 1 && qtd <= 5) {
                return 'primary'
            } else if (qtd >= 6 && qtd <= 10) {
                return 'warning'
            } else if (qtd > 10) {
                return 'danger'
            } else {
                return 'info'
            }
        }
    }
}
</script>
